import React from 'react';

import './style.scss';

export default function MenuItem({ children, className,  ativo, ...rest }) {

    return (
        <div className={`menu-item ${className} ${ativo?'menu-item-ativo':''}`} {...rest}>{children}</div>
    );
}